import request from '@/utils/request'
// 登录
export function getApprovalList(params) {
  return request({
    url: '/auth/v1/applyer',
    method: 'get',
    params
  })
}


export function handleApproval(data) {
  return request({
    url: '/auth/v1/applyer/review',
    method: 'post',
    data
  })
}



export function deleteApproval(data) {
  return request({
    url: '/auth/v1/applyer/delete',
    method: 'post',
    data
  })
}




export function getNoticeList(params) {
  return request({
    url: '/auth/v1/notice',
    method: 'get',
    params
  })
}

